<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-layout column align-space-around pa-5>
        <v-flex pa-5>
            <h1>About Léamh</h1>
            <p>
              Léamh: Learn Early Modern Irish began as a digital humanities project at the University of Connecticut. Originally funded by a seed grant from Connecticut’s Humanities Institute in 2012, the project was envisioned as a means to facilitate the greater use of early modern Irish sources in scholarship across fields and disciplines. In the absence of learning materials – grammar, dictionary and guide – acquisition of Early Modern Irish has always been difficult. Léamh is intended to address that absence by offering guided translations of a wide range of texts and genres, a grammar with basic paradigms and descriptive summaries, and a searchable reference glossary. In time, the site will offer tutelage in reading manuscripts through means of a stand-alone guide to paleography.
            </p>

            <br>

            <h1>Helping People Get Started with Early Modern Irish</h1>
            <p>

              Léamh was begun by non-specialists wishing to help others like themselves gain confidence in reading original-language sources. As such, it is constructed to harness both the insights of learners and the expertise of specialists in the pursuit of optimal learning outcomes. To understand what newcomers to Early Modern Irish might find difficult or confusing, it is necessary to ask them. Thus, each sample text on the site is analyzed and translated by specialists and non-specialists alike. Specialists provide explanation, context, accurate translation, and learning tips and pointers; readers of “intermediate” level work through the texts and identify questions and areas of confusion, which are shared with scholar experts whose responses to those queries form part of the “General Guide” and “Detailed Guide” tabs.


            </p>

            <a href="https://www.leamh.org" target="_blank" rel="noopener noreferrer">Leamh.org website</a>

            <h1>Leamh Quiz App</h1>
            <p>
              In the Spring of 2018, Greenhouse Studios organized a team of researchers and developers to spin up a new project based on the pre-existing work done on the leamh.org website. The team decided to produce a web application for studying Early Modern Irish in a way that was not previously available.
            </p>


            <a href="https://www.greenhousestudios.uconn.edu" target="_blank" rel="noopener noreferrer">Greenhouse Studios</a>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>


<script>
export default{
  name: 'About'
  
}


</script>


<style scoped>
</style>
